import { lazy } from 'react';

const RELOAD_KEY = 'chunk-reload-attempted';

export const lazyWithRetry = (importer, exportName = 'default') =>
  lazy(() =>
    importer()
      .then((module) => {
        sessionStorage.removeItem(RELOAD_KEY);
        return { default: module[exportName] };
      })
      .catch((error) => {
        if (!sessionStorage.getItem(RELOAD_KEY)) {
          sessionStorage.setItem(RELOAD_KEY, '1');
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      })
  );
